exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".free-hosted-videos-wrapper #banner-get-my-fun{margin:30px 0}.free-hosted-videos-wrapper #banner-get-access{margin-top:30px}.free-hosted-videos-wrapper #banner-get-in-touch{margin-bottom:30px}@media screen and (min-width:425px){.free-hosted-videos-wrapper .other-videos.content-list.grid .item{max-width:460px;width:49%}}.free-hosted-videos-wrapper .photos-part#first-photos-part{margin-bottom:25px}.free-hosted-videos-wrapper .photos-part#second-photos-part{margin-bottom:-5px;margin-top:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/css-loader?minimize!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/autoprefixer-loader?{browsers:["last 3 versions"],cascade:false}!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/stylus-loader??ref--6-3!./components/fhg/stylus/_freeHostedVideos.styl
// module id = 471
// module chunks = 4